
import React, { useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import styles from './styles.module.scss';
import EditableText from "@/components/EditableText";
import EditableImage from "@/components/EditableImage";
import clsx from "classnames";
import PropTypes from "prop-types";
import Link from "next/link"
import sourceflowEnums from "@/sourceflow.enums";
import PostCategory from "@/.sourceflow/blog_category.json";
import PostTag from "@/.sourceflow/blog_tags.json";


function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDay = day.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');

    return `${formattedDay}/${formattedMonth}/${year}`;
}

export default function BlogCard({
    className,
    pathPrefix,
    global,
    post,
    // pathURL = "/blog/",
    post_category,
    slug
}) {
    const matchedCategories = PostCategory?.category_values?.filter(category =>
        post.blog_category.includes(category.id)
    );
    const matchedTags = PostTag?.category_values?.filter(category =>
        post.tag.includes(category.id)
    );

    return (
        <Card className={clsx(className, styles.root)}>
            <div className='overflow-hidden'>
                <EditableImage
                    img={post?.banner_image ? post.banner_image : "/images/placeholders/img-placeholder.jpg"}
                    size={`300x150`}
                    alt={`${post.title}`}
                    className={``}
                    height={`100%`}
                />
            </div>
            <div className='p-4'>
                {(matchedCategories.length >= 1 || matchedTags.length >= 1) && (
                    <div className='tags-wrapper mb-3 flex-wrap'>
                        {matchedCategories?.map((category, index) => (
                            <span key={index} className={`${createSlug(category.title.en)}`}>
                                {category.title.en}
                            </span>
                        ))}
                        {matchedTags?.map((category, index) => (
                            <span key={index} className={`${createSlug(category.title.en)}`}>
                                {category.title.en}
                            </span>
                        ))}
                    </div>
                )}
                <div className='post-title h6'><a href={`${matchedCategories?.map((category) => `/${(createSlug(category.title.en))}/${post.url_slug}`)}`} target="_self">{post.title}</a></div>
                <div className="mt-4 post-date">
                    Posted on {formatDate(post.published_date)}
                </div>
            </div >
        </Card >
    )
}

function createSlug(title) {
    return title
        .toLowerCase() // Convert to lowercase
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
}

BlogCard.defaultProps = {
    pathPrefix: "",
    className: "overflow-hidden mb-5",
};

BlogCard.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};